import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function LandingForm() {
    const navigate = useNavigate();
    const [ip, setIp] = useState("");
    const [loading, setLoading] = useState(false);

    const [postData, setPostData] = useState({ name: "", email: "", mobile: "", location: "", project_type: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPostData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Get IP address on component load
        const fetchIp = async () => {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setIp(data.ip);
        };
        fetchIp();
    }, []);

    // Submit handler
    const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
        if (
        key !== "source_url" &&
        key !== "ip_address" &&
        (value === "" || value === null)
        ) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
        }
    }

    if (!/^[0-9]+$/.test(postData.mobile)) {
        toast.error("Phone Number should contain only digits.");
        return;
    }

    if (postData.mobile.length !== 10) {
        toast.error("Phone Number should be exactly 10 digits long.");
        return;
    }

    const payload = {
        ...postData,
        ip_address: ip,
        source_url: sessionStorage.getItem("first_landing_url"),
    };

    setLoading(true);

    try {
        await axios.post(`${BaseUrl}/api/contact-saves`, payload);
        navigate("/thankyou");
    } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("Something went wrong. Please try again.");
    } finally {
        setLoading(false);
    }
    };


    return (
        <>
            <div className="landpage-form">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <h4 className='heading center-heading'>Let’s talk about designing your space.</h4>

                            <div className="box-landform">
                                <div className="landform-area">
                                    <p>Share your contact info and our design team will reach out to discuss your interior needs.</p>

                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-12 col-sm-12">
                                                <label>Full Name</label>
                                                <input value={postData.name} onChange={handleChange} required type="text" name="name" placeholder="Full Name" className="form-control" />
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <label>Phone Number</label>
                                                <input value={postData.mobile} onChange={handleChange} required name="mobile" type="tel" maxLength={10} placeholder="Phone Number" className="form-control" />
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <label>Email Address</label>
                                                <input value={postData.email} onChange={handleChange} required name="email" type="email" placeholder="Your Work Email" className="form-control" />
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <label>City / Location</label>
                                                <input value={postData.location} onChange={handleChange} required type="text" name="location" placeholder="City" className="form-control" />
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <label>Project Type</label>
                                                <select value={postData.project_type} onChange={handleChange} required name="project_type" className="form-control">
                                                    <option value={null}>Select Any</option>
                                                    <option value={"Residential"}>Residential</option>
                                                    <option value={"Commercial"}>Commercial</option>
                                                    <option value={"Renovation"}>Renovation</option>
                                                </select>
                                            </div>

                                            <div className="col-lg-12 col-sm-12">
                                                <button type="submit" className="default-btn colored-btn">
                                                   {loading ? "submitting..." : "Submit Your Request"} <Icons name="Longarrow_right" />
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <img src="/image/landform-img.webp" loading="lazy" className="img-responsive" alt="form" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
